import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import useFetchEligibleQBPAem from "../../../../shared/hooks/useFetchEligibleQBPAem";
import { errorConditionGTM } from "../../../Utils/googleTags";
import useFetchAEMContent from "../../../../../shared/hooks/useFetchAemContents";
import useFetchAemBrspdContents from "../../../../../shared/hooks/useFetchAemBrspdContents";
import ApiUrls from "../../../Utils/axr";

type dslmigratornewContentInitalStateType = {
    dslmigratorNewContent: any;
    loading: boolean;
    error: any;
};
const initialState: dslmigratornewContentInitalStateType = {
    dslmigratorNewContent: null,
    loading: false,
    error: null,
};

const host = window?.location?.host;
const file = 'dsl-migrator.json'

export const getdslMigratornewContent = createAsyncThunk(
    "get/dsl-migratorNew_AEM/content",
    async () => {
        try {
            const response = await useFetchAemBrspdContents({
                [ApiUrls.aem_content]: `${file}?appName=${host}`,
            });
            return response?.data;
        } catch (error) {
            throw error;
        }
    }
);

const dslmigratorNewContentSlice = createSlice({
    name: "not_eligible_payment_AEM/Details",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getdslMigratornewContent.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getdslMigratornewContent.fulfilled, (state, action) => {
            state.dslmigratorNewContent = action.payload;
            state.loading = false;
            state.error = null;
        });
        builder.addCase(getdslMigratornewContent.rejected, (state, action) => {
            errorConditionGTM(
                "BRSPD_Fiber_EC_Flow",
                "non auth AEM content",
                action.error?.message,
                action?.type
            );
            state.dslmigratorNewContent = null;
            state.loading = false;
            state.error = action.error;
        });
    },
});

export default dslmigratorNewContentSlice.reducer;